import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitDetailStats } from '@apps-common/types/portal/unit'

export const QUERY_KEY_MY_MONITORING_GET_SITE_STATS = (unitId?: string) => ['getMyMonitoringSiteStats', unitId].filter(Boolean)

const getSiteStats = async (unitId?: string): Promise<IUnitDetailStats> =>
  axios.get(`my-monitoring/Sites/GetSiteStats?unitId=${unitId}`).then((res) => res.data?.data)

type QueryFnType = typeof getSiteStats

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId?: string
}

export const useMyMonitoringGetSiteStats = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_MY_MONITORING_GET_SITE_STATS(unitId),
    queryFn: () => getSiteStats(unitId)
  })
